// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M2 20.5001H22V22.5001H2V20.5001Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M7 7C7 4.23858 9.23858 2 12 2C14.7614 2 17 4.23858 17 7C17 8.56955 16.2753 10.2975 15.1526 11.4883C14.9901 11.6607 14.8522 11.8446 14.7457 12.0415C14.483 12.5272 14.9477 13 15.5 13L20 13C21.1046 13 22 13.8954 22 15V19.5L2 19.5V15C2 13.8954 2.89543 13 4 13L8.5 13C9.05228 13 9.51703 12.5272 9.25426 12.0415C9.14775 11.8446 9.00993 11.6607 8.84741 11.4883C7.72475 10.2975 7 8.56955 7 7Z"}}]};

const SealFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'seal-filled',
    ref,
    icon: element,
  },
));

SealFilledIcon.displayName = 'SealFilledIcon';

export default SealFilledIcon;
